import sdkSessionUtil from 'bam-browser-sdk-sdkSession-util'; //eslint-disable-line import/no-extraneous-dependencies
import cookies from 'btm.cookies/cookies'; //eslint-disable-line import/no-unresolved, import/extensions
import uuid from '../tracking-minified/uuid';

export const getDSSID = function () {
    return new Promise((resolve) => {
        sdkSessionUtil.getSdkSession()
            .then((session) => {
                session.getSessionInfo()
                    .then((sessionInfo) => {
                        const sessionId = sessionInfo.id || 'error';
                        const deviceId = (sessionInfo.device && sessionInfo.device.id) || 'error';
                        const accountId = (sessionInfo.account && sessionInfo.account.id) || '';

                        let DSSID = `DSSID:${deviceId},${sessionId}`;
                        if (accountId) {
                            DSSID = `${DSSID},${accountId}`;
                        }
                        resolve(DSSID);
                    });
            })
            .catch(() => {
                resolve('DSSID:error,error,error');
            });
    });
};

export const findQueryParamCaseInsensitive = function (searchParam) {
    const searchParamLowerCase = (searchParam || '').toLowerCase();
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if ((pair[0] || '').toLowerCase() === searchParamLowerCase) {
            return pair[1];
        }
    }
    return false;
};

export const getAllQueryStringParams = function () {
    const result = {};
    // Split into key/value pairs
    window.location.search.slice(1).split('&').forEach((queryChunk) => {
        // Convert the array of strings into an object
        const temp = queryChunk.split('=');
        result[temp[0]] = temp[1];
    });
    return result;
};

export const getUnid = function () {
    window.unid = window.unid || { //eslint-disable-line no-param-reassign
        getData(callback) {
            callback(undefined);
        }
    };
    return new Promise((resolve) => {
        const tookTooLong = setTimeout(() => {
            console.warn('unid.getData took too long');
            resolve();
        }, 5000);

        window.unid.getData((data) => {
            clearTimeout(tookTooLong);
            resolve(data && data.unid);
        });
    });
};

export const letterCase = function (word) {
    const result = word || '';
    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
};

export const copyProps = function (from, to) {
    if (from && to) {
        for (const prop in from) {
            if (from.hasOwnProperty(prop)) { //eslint-disable-line no-prototype-builtins
                to[prop] = from[prop];
            }
        }
    }
};

export const validateMissingProperties = function (trackingConfig) {
    // config validation
    [
        'reportingSuiteId',
        'trackingTitle',
        'languageLocale',
        'marketingCloudId',
        'trackingServer',
        'trackingServerSecure'
    ].forEach((expectedConfigProperty) => {
        if (!(expectedConfigProperty in trackingConfig)) {
            console.error(`tracking-suite.js Missing "${expectedConfigProperty}" in trackingConfig: ${trackingConfig}`);
        }
    });
};

export const getPaywallVisitCount = function () {
    let count = cookies.get('paywallvisitcount');
    count = count ? Number(count) : 0;
    count++;

    // set a session cookie to hold the count
    cookies.set('paywallvisitcount', count);
    return count;
};

export const convertGender = function (gender) {
    return {
        1: 'M',
        2: 'F'
    }[gender] || 'not set';
};

export const getLocalSWID = function () {
    // ideally we want the disney one id swid
// but if not logged in, we try to get the ESPN already-set cookie SWID
// if that doesn't exists we need to create a uuid, set that and use it
    const swidCookieKey = 'SWID';
    let swid = cookies.get(swidCookieKey);

    if (!swid) {
        swid = uuid();
        const futureDate = new Date();
        futureDate.setDate(futureDate.getFullYear() + 10);
        cookies.set({
            name: swidCookieKey,
            value: swid,
            domain: '.espn.com',
            path: '/',
            expires: futureDate,
            secure: true
        });
    }
    return swid;
};

export const getVisitorData = function (s) {
    let lastvisit = s.getDaysSinceLastVisit('s_c24'); //days since last visit
    lastvisit = unescape(lastvisit);// handles standard decoding
    lastvisit = unescape(lastvisit);// handles double decoding (doesn't hurt)

    let visitortype = 'Repeat';

    if (lastvisit === 'First Visit') {
        visitortype = 'New';
    } else if (lastvisit === 'Cookies Not Supported') {
        visitortype = lastvisit;
    }
    return {
        lastvisit,
        visitortype
    };
};
